import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

interface IMuiLink {
  defaultProps?: ComponentsProps['MuiLink'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiLink'];
  variants?: ComponentsVariants['MuiLink'];
}

const MuiLinkConfig: IMuiLink = {
  styleOverrides: {
    root: ({ theme: theme2 }) => ({
      fontFamily: theme2.typography.fontFamily,
    }),
  },
};

export default MuiLinkConfig;
